// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3-Ebz","container":"styles_container__3uYy4","title":"styles_title__INF6y","wrapper":"styles_wrapper__Jqd40","answer":"styles_answer__26bHn"};